/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '@repo/graphql-types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions, useMutation, type UseMutationOptions } from '@tanstack/react-query'
export type UserFieldsFragment = { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null };

export type UserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', token?: string | null, user?: { __typename?: 'User', id: string, avatarUrl?: string | null, language: Types.Language, email: string, slug?: string | null, firstName?: string | null, lastName?: string | null, stripeCustomerId: string, roles?: Array<string | null> | null, isTemporary: boolean, isBanned: boolean, bio: string, stripeCustomer?: { __typename?: 'StripeCustomer', id: string, account: Types.StripeAccount } | null, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, subscriptionAccess: { __typename?: 'SubscriptionAccess', allAccess: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, studioAi: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, isEligibleForFreeTrial: boolean, isEligibleForYearlyUpgrade: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, isTrial: boolean, billingPeriod: Types.BillingPeriod, endDate?: any | null, nextPaymentDate?: any | null } | null }, coins: { __typename?: 'SubscriptionAccessDetails', isSubscribed: boolean, subscription?: { __typename?: 'SubscriptionRecord', id: string, type: Types.SubscriptionPlan } | null } }, flags?: { __typename?: 'UserFlags', isNew?: boolean | null, isGAdsSignup?: boolean | null, identifyUser?: boolean | null } | null, affiliateInfo?: { __typename?: 'AffiliateInfo', affiliateId: string } | null } | null, currency?: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type UserAllSubscriptionsTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserAllSubscriptionsTypesQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', user?: { __typename?: 'User', subscriptions?: { __typename?: 'Subscriptions', fonts?: boolean | null, crafts?: boolean | null, graphics?: boolean | null, embroidery?: boolean | null, classes?: boolean | null } | null } | null } | null };

export type DeleteUserAccountMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DeleteUserAccountMutation = { __typename?: 'Mutation', deleteUserAccount: { __typename?: 'DeleteUserAccountResponse', deleted: boolean, error?: { __typename?: 'ErrorGrowth', type: Types.ErrorTypeGrowth, description?: string | null } | null } };

export type LogoutMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'LogoutResponse', logout?: { __typename?: 'StatusMessage', success: boolean, message: string } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };

export type UsersEligibleForDeletionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UsersEligibleForDeletionQuery = { __typename?: 'Query', usersEligibleForDeletion?: { __typename?: 'UserEligibleForDeletionResponse', message: string, canBeDeleted: boolean, reasons?: Array<{ __typename?: 'UserEligibleForDeletionReason', title: string, desc: string }> | null } | null };

export type UserBillingDetailsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserBillingDetailsQuery = { __typename?: 'Query', me?: { __typename?: 'AuthResponse', token?: string | null, user?: { __typename?: 'User', id: string, stripeCustomerId: string, firstName?: string | null, lastName?: string | null, email: string, currency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }, billingDetails: { __typename?: 'BillingDetails', taxId?: string | null, euTaxId: string, address: { __typename?: 'Address', line1: string, line2: string, city: string, state: string, postalCode: string, country: string } } } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } | null };


export const DeleteUserAccountDocument = `
mutation deleteUserAccount {
  deleteUserAccount {
    error {
      type
      description
    }
    deleted
  }
}

`

export const deleteUserAccountMutationKey = 'deleteUserAccount'

export function deleteUserAccountMutationFetcher(variables?: DeleteUserAccountMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<DeleteUserAccountMutation, DeleteUserAccountMutationVariables>(DeleteUserAccountDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useDeleteUserAccountMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<DeleteUserAccountMutation, E, DeleteUserAccountMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<DeleteUserAccountMutation, E, DeleteUserAccountMutationVariables, C>({
        ...options,
        mutationKey: [deleteUserAccountMutationKey],
        mutationFn: (variables?: DeleteUserAccountMutationVariables) => deleteUserAccountMutationFetcher(variables, fetchOptions),
    })
}

export const LogoutDocument = `
mutation logout {
  logout {
    logout {
      success
      message
    }
    errors {
      code
      message
    }
  }
}

`

export const logoutMutationKey = 'logout'

export function logoutMutationFetcher(variables?: LogoutMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<LogoutMutation, LogoutMutationVariables>(LogoutDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useLogoutMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<LogoutMutation, E, LogoutMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<LogoutMutation, E, LogoutMutationVariables, C>({
        ...options,
        mutationKey: [logoutMutationKey],
        mutationFn: (variables?: LogoutMutationVariables) => logoutMutationFetcher(variables, fetchOptions),
    })
}

export const UserDocument = `
query user {
  me {
    token
    user {
      ...UserFields
    }
    currency {
      code
      symbol
    }
    errors {
      code
      message
    }
  }
}
fragment UserFields on User {
  id
  avatarUrl
  language
  email
  slug
  firstName
  lastName
  stripeCustomerId
  stripeCustomer {
    id
    account
  }
  roles
  currency {
    code
    symbol
  }
  subscriptionAccess {
    allAccess {
      isSubscribed
      isEligibleForFreeTrial
      isEligibleForYearlyUpgrade
      subscription {
        id
        isTrial
        billingPeriod
        endDate
        nextPaymentDate
      }
    }
    studioAi {
      isSubscribed
      isEligibleForFreeTrial
      isEligibleForYearlyUpgrade
      subscription {
        id
        isTrial
        billingPeriod
        endDate
        nextPaymentDate
      }
    }
    coins {
      isSubscribed
      subscription {
        id
        type
      }
    }
  }
  flags {
    isNew
    isGAdsSignup
    identifyUser
  }
  affiliateInfo {
    affiliateId
  }
  isTemporary
  isBanned
  bio
}
`

export const userQueryRootKey = 'user'

export function userQueryFetcher(variables?: UserQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserQuery, UserQueryVariables>(UserDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userQueryKey(variables?: UserQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userQueryOptions(
    variables?: UserQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserQuery, unknown, UserQuery, (UserQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userQueryKey(variables, fetchOptions),
        queryFn: userQueryFetcher(variables, fetchOptions),
    }
}

export function useUserQuery<D = UserQuery, E = unknown>(
    variables?: UserQueryVariables,
    options?: Omit<UseQueryOptions<UserQuery, E, D, (UserQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserQuery, E, D, (UserQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userQueryOptions(variables, fetchOptions),
    })
}

export const UserAllSubscriptionsTypesDocument = `
query userAllSubscriptionsTypes {
  me {
    user {
      subscriptions {
        fonts
        crafts
        graphics
        embroidery
        classes
      }
    }
  }
}

`

export const userAllSubscriptionsTypesQueryRootKey = 'userAllSubscriptionsTypes'

export function userAllSubscriptionsTypesQueryFetcher(variables?: UserAllSubscriptionsTypesQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserAllSubscriptionsTypesQuery, UserAllSubscriptionsTypesQueryVariables>(UserAllSubscriptionsTypesDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userAllSubscriptionsTypesQueryKey(variables?: UserAllSubscriptionsTypesQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userAllSubscriptionsTypesQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userAllSubscriptionsTypesQueryOptions(
    variables?: UserAllSubscriptionsTypesQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserAllSubscriptionsTypesQuery, unknown, UserAllSubscriptionsTypesQuery, (UserAllSubscriptionsTypesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userAllSubscriptionsTypesQueryKey(variables, fetchOptions),
        queryFn: userAllSubscriptionsTypesQueryFetcher(variables, fetchOptions),
    }
}

export function useUserAllSubscriptionsTypesQuery<D = UserAllSubscriptionsTypesQuery, E = unknown>(
    variables?: UserAllSubscriptionsTypesQueryVariables,
    options?: Omit<UseQueryOptions<UserAllSubscriptionsTypesQuery, E, D, (UserAllSubscriptionsTypesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserAllSubscriptionsTypesQuery, E, D, (UserAllSubscriptionsTypesQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userAllSubscriptionsTypesQueryOptions(variables, fetchOptions),
    })
}

export const UsersEligibleForDeletionDocument = `
query usersEligibleForDeletion {
  usersEligibleForDeletion {
    message
    canBeDeleted
    reasons {
      title
      desc
    }
  }
}

`

export const usersEligibleForDeletionQueryRootKey = 'usersEligibleForDeletion'

export function usersEligibleForDeletionQueryFetcher(variables?: UsersEligibleForDeletionQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UsersEligibleForDeletionQuery, UsersEligibleForDeletionQueryVariables>(UsersEligibleForDeletionDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function usersEligibleForDeletionQueryKey(variables?: UsersEligibleForDeletionQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [usersEligibleForDeletionQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function usersEligibleForDeletionQueryOptions(
    variables?: UsersEligibleForDeletionQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UsersEligibleForDeletionQuery, unknown, UsersEligibleForDeletionQuery, (UsersEligibleForDeletionQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: usersEligibleForDeletionQueryKey(variables, fetchOptions),
        queryFn: usersEligibleForDeletionQueryFetcher(variables, fetchOptions),
    }
}

export function useUsersEligibleForDeletionQuery<D = UsersEligibleForDeletionQuery, E = unknown>(
    variables?: UsersEligibleForDeletionQueryVariables,
    options?: Omit<UseQueryOptions<UsersEligibleForDeletionQuery, E, D, (UsersEligibleForDeletionQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UsersEligibleForDeletionQuery, E, D, (UsersEligibleForDeletionQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...usersEligibleForDeletionQueryOptions(variables, fetchOptions),
    })
}

export const UserBillingDetailsDocument = `
query userBillingDetails {
  me {
    token
    user {
      currency {
        code
        symbol
      }
      id
      stripeCustomerId
      firstName
      lastName
      email
      billingDetails {
        taxId
        euTaxId
        address {
          line1
          line2
          city
          state
          postalCode
          country
        }
      }
    }
    errors {
      code
      message
    }
  }
}

`

export const userBillingDetailsQueryRootKey = 'userBillingDetails'

export function userBillingDetailsQueryFetcher(variables?: UserBillingDetailsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserBillingDetailsQuery, UserBillingDetailsQueryVariables>(UserBillingDetailsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userBillingDetailsQueryKey(variables?: UserBillingDetailsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userBillingDetailsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userBillingDetailsQueryOptions(
    variables?: UserBillingDetailsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserBillingDetailsQuery, unknown, UserBillingDetailsQuery, (UserBillingDetailsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userBillingDetailsQueryKey(variables, fetchOptions),
        queryFn: userBillingDetailsQueryFetcher(variables, fetchOptions),
    }
}

export function useUserBillingDetailsQuery<D = UserBillingDetailsQuery, E = unknown>(
    variables?: UserBillingDetailsQueryVariables,
    options?: Omit<UseQueryOptions<UserBillingDetailsQuery, E, D, (UserBillingDetailsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserBillingDetailsQuery, E, D, (UserBillingDetailsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userBillingDetailsQueryOptions(variables, fetchOptions),
    })
}